<ion-item class="payment-row" lines="none">
  <div class="payment-row-container">
    <div class="payment-column">
      <div class="payment-title">
        <div class="reference-number">
          <p data-cy="payment-row-reference-number">
            {{ paymentRowText.referenceNumber }}:
            <a (click)="onReferenceNumberClick()" href="javascript:void(0)">
              {{ vm?.referenceNumber }}
            </a>
          </p>
        </div>
        <div
          class="status"
          [ngClass]="{
            red: vm?.status === Status.PENDING
          }"
        >
          <p data-cy="payment-row-status">
            {{ vm?.status | titlecase }}
          </p>
        </div>
      </div>
      <div class="payment-content">
        <div>
          <p data-cy="payment-row-payment-method">
            {{ paymentRowText.paymentMethod }}:
            {{ 'i18n.payments.paymentMethod.' + vm?.paymentMethod | translate }}
          </p>
          <p data-cy="payment-row-payment-date">
            {{ paymentRowText.paymentDate }}:
            {{ vm?.paymentDate | date: 'M/d/yyyy':'GMT' }}
          </p>
          <p data-cy="payment-row-item-count">
            {{ paymentRowText.items }}: {{ vm?.itemCount }}
          </p>
          <p data-cy="payment-row-customer-count">
            {{ paymentRowText.customers }}: {{ vm?.customerCount }}
          </p>
        </div>

        <div class="payment-amount" data-cy="payment-row-payment-amount">
          <p>{{ paymentRowText.paymentAmount }}</p>
          <p class="total-amount">
            {{ vm?.totalPaymentAmount | currency }}
          </p>
        </div>
      </div>
    </div>

    <div class="buttons-column">
      <ion-icon
        color="success"
        name="ellipsis-vertical"
        data-cy="payment-row-more-options-mobile-btn"
        (click)="onMoreOptionsClick($event)"
      >
      </ion-icon>
    </div>
  </div>
</ion-item>
